export enum EntryPointType {
    CUSTOM = 'customMessage',
    SHARE = 'share',
    BOT = 'botMessage',
    XPROMO = 'xpromo',
    AD = 'adCampaign',
}
